import Base from "components/Base";
import { useToastContext } from "components/alert/ToastContext";
import { EmailAuthProvider } from 'firebase/auth';
import Usuario from "model/administracao/cadastro/Usuario";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import ContaService from "service/administracao/cadastro/ContaService";
import UsuarioService from "service/administracao/cadastro/UsuarioService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import FirebaseService from "../../firebase/FirebaseService";

const usuarioService = new UsuarioService();
const usuarioLogadoService = new UsuarioLogadoService();
const contaService = new ContaService();

export default function UsuarioPerfilCadastro() {

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const [usuario, setUsuario] = useState<Usuario>(new Usuario());
    const [titulo, setTitulo] = useState<string>('');

    const [dialogTrocarSenha, setDialogTrocarSenha] = useState<boolean>(false);
    const [senhaAtual, setSenhaAtual] = useState<string>('');
    const [senhaNova, setSenhaNova] = useState<string>('');
    const [senhaNovaConfirmacao, setSenhaNovaConfirmacao] = useState<string>('');

    useEffect(() => {

        usuarioService.consultar(usuarioLogadoService.getUsuario().id).then(usu => {
            setUsuario(usu);
        });

    }, []);

    function validar() {

        if (usuario.nome) {
            return true;
        }

        return false;
    }

    function gravar() {

        if (validar()) {

            startLoading();

            usuarioService.
                editar(usuario)
                .then((usuarioRetorno: Usuario) => {
                    stopLoading();
                    setUsuario(usuarioRetorno);
                    msgSucesso('Usuário', 'Registro gravado com sucesso');
                })
                .catch(error => {
                    console.error(error);
                    stopLoading();
                    msgErro('Usuário', 'Ocorreu um erro ao tentar gravar, tente novamente!');
                });

        } else {
            msgAlerta('Usuário', 'Favor, preencher todos os campos obrigatórios');
        }

    }

    function trocarSenha() {
        setSenhaAtual('');
        setSenhaNova('');
        setSenhaNovaConfirmacao('');
        setDialogTrocarSenha(true);
    }

    function confirmarTrocaSenha() {

        if (senhaAtual && senhaNova) {

            if (senhaNova === senhaNovaConfirmacao) {

                const auth = FirebaseService.getApp().auth();
                const user = auth.currentUser;

                if (user && user.email) {

                    const credential = EmailAuthProvider.credential(
                        user.email,
                        senhaAtual
                    )

                    startLoading();

                    user.reauthenticateWithCredential(credential).then(() => {
                        user.updatePassword(senhaNova).then(() => {
                            stopLoading();
                            setDialogTrocarSenha(false);
                            msgSucesso('Trocar Senha', 'Senha alterada com sucesso');
                        }).catch((e) => {
                            stopLoading();
                            if (e.code === 'auth/weak-password') {
                                msgAlerta('Trocar Senha', 'Favor informar uma senha mais forte, mínimo 6 caracteres');
                            } else {
                                console.warn(e);
                                msgAlerta('Trocar Senha', 'Ocorreu um erro não esperado ao cadastrar usuário');
                            }
                        })
                    }).catch((e) => {
                        stopLoading();
                        if (e.code === 'auth/wrong-password') {
                            msgAlerta('Trocar Senha', 'A senha atual não é válida');
                        } else {
                            console.error(e);
                        }
                    });

                }


            } else {
                msgAlerta('Trocar Senha', 'As senhas devem ser iguais');
            }

        } else {
            msgAlerta('Trocar Senha', 'Favor informar a senha atual e a nova senha');
        }

    }

    return (

        <Base tituloPagina={'Usuário'}>

            <Dialog header="Trocar senha" visible={dialogTrocarSenha} style={{ width: '350px' }} onHide={() => setDialogTrocarSenha(false)}>
                <div>
                    <div className="row">
                        <label className="col col-sm-12">Senha atual</label>
                        <div className="col-sm-12">
                            <InputText type='password' value={senhaAtual} style={{ width: '100%' }} onChange={(e) => setSenhaAtual(e.target.value)} />
                        </div>
                    </div>
                    <div className="row">
                        <label className="col col-sm-12">Senha nova</label>
                        <div className="col-sm-12">
                            <InputText type='password' value={senhaNova} style={{ width: '100%' }} onChange={(e) => setSenhaNova(e.target.value)} />
                        </div>
                    </div>
                    <div className="row">
                        <label className="col col-sm-12">Senha nova (confirmação)</label>
                        <div className="col-sm-12">
                            <InputText type='password' value={senhaNovaConfirmacao} style={{ width: '100%' }} onChange={(e) => setSenhaNovaConfirmacao(e.target.value)} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                            <Button type="button" label="Cancelar" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => setDialogTrocarSenha(false)}></Button>
                            <Button type="button" label="Gravar" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => confirmarTrocaSenha()}></Button>
                        </div>
                    </div>
                </div>
            </Dialog>

            <div className="container">

                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>

                <div className="row">
                    <label className="col col-sm-12" style={{ fontWeight: 700 }}>Nome</label>
                    <div className="col-sm-12">
                        <InputText required value={usuario.nome} onChange={(e) => setUsuario({ ...usuario, nome: e.target.value })} style={{ width: '100%' }} />
                    </div>
                </div>

                <div className="row">
                    <label className="col col-sm-12" style={{ fontWeight: 700 }}>E-mail</label>
                    <div className="col-sm-12">
                        <InputText required value={usuario.email} disabled={usuario.id > 0} onChange={(e) => setUsuario({ ...usuario, email: e.target.value })} style={{ width: '100%' }} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <Button type="button" label="Trocar senha" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => trocarSenha()}></Button>
                        <Button type="button" label="Gravar" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => gravar()}></Button>
                    </div>
                </div>
            </div>
        </Base>

    )
}
